export const PAGES = {
  TERMS_OF_USE: {
    id: 1,
    slug: 'terms-of-use',
  },
  PRIVACY_POLICY: {
    id: 2,
    slug: 'privacy-policy',
  },
  AGREEMENT: {
    id: 3,
    slug: 'agreement',
  },
};
